<h1 mat-dialog-title>{{ data.item.code }} - Upload Attachments</h1>
<div mat-dialog-content>
  <div class="flex flex-col" [formGroup]="form">
    <div class="flex flex-row items-center justify-center lg:basis-1/3 w-full">
      <ng-container *ngIf="form.value.files; else selectFile">
        <div class="flex flex-col w-full">
          <p class="w-full" *ngFor="let file of form.value.files">
            {{ file.name }} ({{ file.size | filesize }})
          </p>
        </div>
      </ng-container>
      <ng-template #selectFile>
        <div class="flex flex-col w-full space-y">
          <p>
            If you are using a mobile device with a camera use the Capture
            buttons to open the camera.
          </p>
          <div
            class="flex flex-col space-y-4 md:my-6 md:flex-row justify-center items-center md:space-y-0 md:space-x-8"
          >
            <input
              type="file"
              class="hidden"
              id="file"
              multiple
              (change)="handleFileInput($event.target)"
            />
            <label
              for="file"
              class="mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base cursor-pointer flex flex-row items-center justify-center space-x-4 my-12"
            >
              <mat-icon>upload</mat-icon>
              <p>Select Files</p>
            </label>
            <input
              type="file"
              class="hidden"
              capture="environment"
              id="image-capture"
              multiple
              accept="image/*"
              (change)="handleFileInput($event.target)"
            />
            <label
              for="image-capture"
              class="mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base cursor-pointer flex flex-row items-center justify-center space-x-4 my-12"
            >
              <mat-icon>photo_camera</mat-icon>
              <p>Capture Image</p>
            </label>
            <input
              type="file"
              class="hidden"
              capture="environment"
              multiple
              id="video-capture"
              accept="video/*"
              (change)="handleFileInput($event.target)"
            />
            <label
              for="video-capture"
              class="mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base cursor-pointer flex flex-row items-center justify-center space-x-4 my-12"
            >
              <mat-icon>videocam</mat-icon>
              <p>Capture Video</p>
            </label>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="form.value.files">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input
          matInput
          formControlName="description"
          placeholder="Description"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Stage</mat-label>
        <mat-select formControlName="stage">
          <mat-option *ngFor="let stage of stages" [value]="stage.value">{{
            stage.label
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="uploading$ | async">
    Cancel
  </button>
  <button
    mat-button
    (click)="uploadAttachment()"
    color="primary"
    [disabled]="form.invalid || (uploading$ | async)"
  >
    Add
  </button>
</div>
